import styled from 'styled-components';

export const WellBeingContainerStyled = styled.div`
  .title_layout {
    margin-bottom: 19px;
  }
`;
